export const GREETING_IMG_SRC = '/ui-assets/access/images/hello.svg';
